<template>
  <div>
    <div :id="namespaceDiffusionLivres">
      <b-col cols="12">
        <h2 :class="showDetails.diffusionLivres ? 'rotate active' : 'no-rotate'">
          Diffusion des livres
          <i
            class="fas fa-chevron-left"
            @click="toggleDiffusionLivres"
          />
          <span class="separator" />
        </h2>
      </b-col>
      <b-col
        v-show="showDetails.diffusionLivres"
        :id="'liste_stats_' + namespaceDiffusionLivres"
        cols="12"
      >
        <GenericTable
          :ref="refGenericTableDiffusionLivres"
          :name="namespaceDiffusionLivres"
          :actions="getActions(namespaceDiffusionLivres)"
          :colonnes="cols"
          :endpoint-url="endpointUrl"
          :filterable-col="filterableCol"
          :extra-filters="extraFilters.diffusionLivres"
          verbose-namespace="Diffusion des livres"
          @row-click="
            openDetails(
              $event,
              namespaceDiffusionLivres,
              'global',
              'diffusion des livres'
            )
          "
          @action-callback="
            dispatchAction(
              $event,
              refGenericTableDiffusionLivres,
              namespaceDiffusionLivres,
              'global',
              'diffusion des livres'
            )
          "
        />
      </b-col>
    </div>

    <div :id="namespaceRecapFy">
      <b-col cols="12">
        <h2 :class="showDetails.recapFy ? 'rotate active' : 'no-rotate'">
          Récap. par année fiscale
          <i
            class="fas fa-chevron-left"
            @click="toggleRecapFy"
          />
          <span class="separator" />
        </h2>
      </b-col>
      <b-col
        v-show="showDetails.recapFy"
        :id="'liste_stats_' + namespaceRecapFy"
        cols="12"
      >
        <GenericTable
          :ref="refGenericTableRecapFy"
          :name="namespaceRecapFy"
          :actions="getActions(namespaceRecapFy)"
          :colonnes="cols"
          :endpoint-url="endpointUrl"
          :filterable-col="filterableCol"
          :extra-filters="extraFilters.recapFy"
          verbose-namespace="Récap. année fiscale"
          @row-click="
            openDetails(
              $event,
              namespaceRecapFy,
              'global',
              'récap. année fiscale'
            )
          "
          @action-callback="
            dispatchAction(
              $event,
              refGenericTableRecapFy,
              namespaceRecapFy,
              'global',
              'récap. année fiscale'
            )
          "
        />
      </b-col>
    </div>

    <StatsModal :generic-table-namespace="namespaceTab" />
  </div>
</template>

<script>
import MixinStats from "@/mixins/mixinStats";

export default {
  name: "ListeStatsGlobal",
  mixins: [MixinStats],
  data() {
    return {
      refGenericTableDiffusionLivres: "tabDiffusionLivresGlobal",
      refGenericTableRecapFy: "tabRecapFyGlobal",

      namespaceDiffusionLivres: "diffusion_livres",
      namespaceRecapFy: "recap_fy",

      showDetails: {
        diffusionLivres: false,
        recapFy: false,
      },

      extraFilters: {
        diffusionLivres: {
          type: "global",
          sous_type: "diffusion des livres",
        },
        recapFy: {
          type: "global",
          sous_type: "récap. année fiscale",
        },
      },
    };
  },
  methods: {
    /**
     * Affiche/masque le tableau des diffusions des livres et définit le namespace du tableau de recherche.
     * @public
     */
    toggleDiffusionLivres() {
      this.showDetails.diffusionLivres = !this.showDetails.diffusionLivres;
      this.$store.commit("setNamespaceSearch", 0);
    },
    /**
     * Affiche/masque le tableau des récapitulatifs par année ficale et définit le namespace du tableau de recherche.
     * @public
     */
    toggleRecapFy() {
      this.showDetails.recapFy = !this.showDetails.recapFy;
      this.$store.commit("setNamespaceSearch", 1);
    },
  },
};
</script>

<style lang="scss">
@use "@/assets/style/_stats.scss";
</style>
